<template>
  <v-app>
    <v-container>
      <configuration-firstscreen
        v-if="showFirstScreen"
        :configuration-type="configuration.type"
        :planogramms="configuration.planogramm"
        :screen="configuration.interface_description.first_screen"
        :nomenclatures="nomenclatures"
        @data="onStartToPay"
        @screen="onShowSecondScreen"
      />
      <!--      SecondScreen-->
      <configuration-second-screen
        v-if="showSecondScreen"
        :configuration-type="configuration.type"
        :item="itemForSecondScreen"
        :planogramms="configuration.planogramm"
        :screen="configuration.interface_description.first_screen"
        @cancel="onShowFirstScreen"
        @data="onStartToPay"
      />
      <!-- ErrorScreen -->
      <configuration-error-screen
        v-if="showErrorScreen"
        :screen="configuration.interface_description.error_screen"
      />
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
  </v-app>
</template>
<script>
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import { guid, setScreenBackground } from "@/views/loyalty/shared/modules/utilities"
import { configuration, ConfigurationTypeEnum } from "@/views/loyalty/models/justpay-configuration.model"
import ConfigurationFirstscreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationFirstscreen.vue"
import ConfigurationSecondScreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationSecondScreen.vue"
import ConfigurationErrorScreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationErrorScreen.vue"

export default {
  components: { ConfigurationErrorScreen, ConfigurationSecondScreen, ConfigurationFirstscreen },
  data: () => ({
    amountForPay: 0,
    anyAmount: "0",
    configuration: configuration,
    // errorScreen: false,
    // firstScreen: true,
    guid: null,
    itemForSecondScreen: {},
    nomenclatures: [],
    overlay: false,
    paymentService: null,
    planogramm: {},
    pointId: '',
    priceOfGoods: 0,
    secondScreen: false,
    showErrorScreen: false,
    showFirstScreen: true,
    showSecondScreen: false,
    showFinalScreen: false,
  }),
  computed: {
    ConfigurationTypeEnum () {
      return ConfigurationTypeEnum
    }
  },
  watch: {
    showErrorScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.error_screen.background)
      }
    },
    showFirstScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.first_screen.background)
      }
    },
  },
  async beforeMount () {
    this.paymentService = new JustpayPaymentSystemService()
    this.pointId = this.$route.query.id
    localStorage.setItem('pointId', this.pointId)
    console.log('pointId', this.pointId)
    const response = await this.paymentService.getEntities(this.pointId)
    console.log('response', response)
    if (!response.value.error) {
      console.log('Success!')
      this.configuration = response.value.data.configuration
      this.nomenclatures = response.value.data.nomenclatures
    }
  },
async mounted () {
  this.guid = guid()
},
methods: {
/*     // add digit to sum
  onAdd (item) {
    // if (this.anyAmount[0] == 0) { this.anyAmount = this.anyAmount.substring(1) }
    this.anyAmount = this.anyAmount.replace(/^0+/g, '')
    this.anyAmount = this.anyAmount + item
  },
  // remove digit from sum
  onBackspace () {
    const length = this.anyAmount.length
    this.anyAmount = this.anyAmount.substring(0, length - 1)
  },
  onCancel () {
    this.firstScreen = true
    this.secondScreen = false
  },
  // ready to pay
  async onChooseItem (planogramm) {
    this.planogramm = planogramm
    if (this.configuration.type === ConfigurationTypeEnum.Donation) {
      if (planogramm.price_cashless == 0) {
        this.firstScreen = false
        this.secondScreen = true
        this.errorScreen = false
        this.priceOfGoods = planogramm.price_cashless
      } else {
        this.amountForPay = planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        console.log('nomenclature', nomenclature)
        const items = [{
          name: nomenclature.name,
          count: 1,
          amount: this.amountForPay,
          price: this.amountForPay
        }]
        await this.startToPay(items, this.planogramm.nomenclature)
      }
    }
    if (this.configuration.type === ConfigurationTypeEnum.Vitrina || this.configuration.type === ConfigurationTypeEnum.Rele) {
      if (planogramm.amount == 0 || !planogramm.amount) {
        this.firstScreen = false
        this.secondScreen = true
        this.errorScreen = false
        this.priceOfGoods = planogramm.price_cashless
      } else {
        this.amountForPay = planogramm.amount * planogramm.price_cashless
        console.log('this.amountForPay', this.amountForPay)
        const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        console.log('nomenclature', nomenclature)
        const items = [{
          name: nomenclature.name,
          count: this.planogramm.amount,
          amount: this.amountForPay,
          price: planogramm.price_cashless
        }]
        await this.startToPay(items, this.planogramm.nomenclature)
      }
    }
  },
  // ready to pay
  async onOk () {
    let items = []
    if (this.configuration.type === ConfigurationTypeEnum.Donation) {
      this.amountForPay = this.anyAmount
      console.log('this.amountForPay', this.amountForPay)
      const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
      console.log('nomenclature', nomenclature)
      items = [{
        name: nomenclature.name,
        count: 1,
        amount: this.amountForPay,
        price: this.amountForPay
      }]
    }
    if (this.configuration.type === ConfigurationTypeEnum.Vitrina) {
      this.amountForPay = this.anyAmount * this.priceOfGoods
      console.log('this.amountForPay', this.amountForPay)
      const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
      console.log('nomenclature', nomenclature)
      items = [{
        name: nomenclature.name,
        count: this.anyAmount,
        amount: this.amountForPay,
        price: this.priceOfGoods
      }]
    }
    await this.startToPay(items, this.planogramm.nomenclature)
  }, */
  onShowFirstScreen () {
    this.showFirstScreen = this.showScreen()
  },
  onShowSecondScreen (item) {
    console.log('onShowSecondScreen item', item)
    this.itemForSecondScreen = item
    this.showSecondScreen = this.showScreen()
  },
  showOnTheButton (planogramm) {
    let itemToShow = 0
    if (this.configuration.type === ConfigurationTypeEnum.Donation) {
      itemToShow = planogramm.price_cashless
    }
    if (this.configuration.type === ConfigurationTypeEnum.Vitrina || this.configuration.type === ConfigurationTypeEnum.Rele) {
      itemToShow = planogramm.amount
    }
    return itemToShow
  },
  onReloadWindow () {
    window.location.reload()
  },
  async onStartToPay (items, /* nomenclatureId */) {
    this.overlay = true
    const response = await this.paymentService.createPayment({ idempotency: this.guid, /* nomenclatureId: nomenclatureId, */ pointId: this.pointId, items: items, sum: items[0].amount, resultPage: 2 }) // resultPage = 2 (ResultPageEnum.QrWithoutOrderPay)
    this.overlay = false
    console.log('response for nspk', response)
    if (response.value.error) {
      this.firstScreen = false
      this.secondScreen = false
      this.errorScreen = true
      console.log('error', response.value.error)
    } else {
      this.firstScreen = true
      this.secondScreen = false
      const nspkLink = response.value.data.qr
      // window.open(nspkLink, '_blank')
      window.open(nspkLink, '_self')
    }
  },
  showScreen () {
    this.showErrorScreen = false
    // this.showFinalScreen = false
    this.showFirstScreen = false
    // this.showPaymentScreen = false
    // this.showRelayScreen = false
    this.showSecondScreen = false
    return true
  },

  // unitOfMeasure (type) {
  //   if (type == 0) return 'руб.'
  //   if (type == 1) return 'шт.'
  // }
}
}
</script>

<style scoped>
.test {
  font-size: 10px;

}
</style>
